import React, { useEffect, useState } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Row from "./Row";
import { Pager } from "../../../components/Pager";
import { PageLimit } from "..";
import Loader from "../../../components/Loader";
import { useParams } from "react-router";
import { useUser } from "../../../context";
import customers from "../../../i11/Customers";

const Table = ({
	className,
	activeTable,
	setFilter,
	onClose,
	filter,
	res,
	isLoading,
	...rest
}) => {
	const { locale } = useUser();
	const { type } = useParams();
	const [activeId, setActiveId] = useState("");
	const [page, setPage_] = useState(1);
	const [total, setTotal] = useState(1);
	const [data, setData] = useState([]);

	useEffect(() => {
		if (res) {
			setData(res.users);
			setTotal(Math.ceil(res.count / PageLimit));
		}
	}, [res]);

	const setPage = (e) => {
		setPage_(e);
		const lOffset = (e - 1) * PageLimit;
		if (filter.offset !== lOffset)
			setFilter((p) => {
				return {
					...p,
					offset: lOffset,
				};
			});
	};

	useEffect(() => {
		onClose();
	}, [type]);

	return (
		<div className={cn(styles.wrapper, className)}>
			<div className={cn(styles.table)}>
				<div
					className={cn(styles.row, { [styles.active]: activeTable })}
				>
					<div className={styles.col} />
					<div className={styles.col}>{customers[locale].name}</div>
					<div className={styles.col}>{customers[locale].email}</div>
					<div className={styles.col}>
						{customers[locale].referral}
					</div>
					{type !== "admin" && (
						<div className={styles.col}>
							{customers[locale].status}
						</div>
					)}
					<div className={styles.col}>
						{customers[locale].created}
					</div>
				</div>
				{!isLoading &&
					data.map((x) => (
						<Row
							item={x}
							key={x._id}
							activeTable={activeTable}
							activeId={activeId}
							setActiveId={setActiveId}
							{...rest}
						/>
					))}
			</div>
			{isLoading && <Loader className={styles.loader} />}
			<div className={styles.foot}>
				<Pager page={page} setPage={setPage} total={total} />
			</div>
		</div>
	);
};

export default Table;
